<template>
    <ul class="nav">
        <li><router-link to="/coaches/all-court">All Courts</router-link></li>
        <li><router-link to="/coaches/court-active">Active Courts</router-link></li>
        <li><router-link to="/coaches/court-inactive">Inactive Courts</router-link></li>
    </ul>
</template>